import React from 'react';
import styles from './ChatInterface.module.css';

/**
 * TRAC-959: the two static notices that frame the composer, extracted so the
 * loading skeleton (ChatSkeleton.tsx) can draw the exact same elements the
 * chat draws — same markup, same classes — instead of an approximation that
 * lands a few pixels off and makes the first paint jump.
 */

/** TRAC-195: shown above the input while the conversation is still empty. */
export const BetaDisclaimer: React.FC = () => (
  <div className={`${styles.betaDisclaimerAboveInput} ${styles.embedBetaDisclaimer}`}>
    <div className={styles.betaDisclaimer}>
      <strong>Beta</strong> - This experience is still improving and
      may make mistakes. Your feedback helps improve accuracy.
    </div>
  </div>
);

/** Anchored to the bottom of the widget on every opening. */
export const LegalDisclaimer: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`${styles.legalDisclaimer} ${styles.embedLegalDisclaimer}${className ? ` ${className}` : ''}`}>
    By using AI Assist (Beta), you agree to our{' '}
    <a href="https://www.tirerack.com/customer-support/terms" target="_blank" rel="noopener noreferrer">
      Terms of Use
    </a>
    {' '}and{' '}
    <a href="https://www.tirerack.com/about/privacy.jsp" target="_blank" rel="noopener noreferrer">
      Privacy Policy
    </a>. Don't share sensitive info. Chats may be logged.
  </div>
);
